<template>
  <div class="yo-btn" @click="$emit('click')" :style="styler">
    <div style="user-select: none;">
      {{ cta || 'Press here to Enter Live Discussion/Chat Room' }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    styler: {
      default () {
        return {}
      }
    },
    cta: {
      default: false
    }
  }
}
</script>

<style scoped>
.yo-btn{
  /* width: 700px; */
  height: 100px;
  background-color: red;
  color: white;
  font-size: 27px;
  border-radius: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  box-shadow: 0px 0px 30px 0px #f9acac inset, 0px 0px 30px 0px #f9acac;
  margin: 30px;
  box-sizing: border-box;
}
</style>
